import { takeEvery, all, put, call } from "redux-saga/effects"
import { delay } from "./utils"
import { DckActionTypes } from "dck-redux"

function* asyncProcessResetSaga(action) {
  yield call(delay, 5000)
  yield put({
    type: DckActionTypes.ASYNC_PROCESS_RESET,
    processCode: action.processCode
  })
}

function* asyncProcessSaga() {
  yield all([
    takeEvery(DckActionTypes.ASYNC_PROCESS_STOP, asyncProcessResetSaga)
  ])
}

export default asyncProcessSaga



// WEBPACK FOOTER //
// ./src/redux/sagas/asyncprocess.js